import { createRouter, createWebHistory } from 'vue-router'
import Create from '../views/Create.vue'
import MyWork from '../views/MyWork.vue'
import MusicPlayer from '../views/MusicPlayer.vue'
import MusicList from '../views/MusicList.vue'
import tracker from '../utils/tracker';
import adminRoutes from './admin';

const routes = [
  ...adminRoutes,
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'SUNOSONG - AI音乐创作平台 | 人人都是音乐家',
      description: 'SUNOSONG是一个AI音乐创作平台，让任何人都能轻松创作高质量音乐。输入你的想法，立即生成专属歌曲！',
      keywords: 'AI音乐创作,AI生成音乐,在线音乐制作,原创音乐,音乐创作工具'
    }
  },
  {    path: '/create',    name: 'create',    component: Create,    meta: {      title: 'AI音乐创作 - 在线生成歌曲 | SUNOSONG',      description: '使用SUNOSONG的AI音乐创作工具，输入你的想法，立即生成专属歌曲。支持多种风格和语言。',      keywords: 'AI音乐创作,在线生成歌曲,音乐制作工具,AI作曲'    }  },
  {    path: '/mywork',    name: 'mywork',    component: MyWork,    meta: {      title: '我的作品 - 个人音乐库 | SUNOSONG',      description: '管理和查看你在SUNOSONG创作的所有音乐作品，分享你的音乐创作成果。',      keywords: '个人音乐库,我的作品,音乐管理,SUNOSONG'    }  },
  {
    path: '/member',
    name: 'member',
    component: () => import('../views/Member.vue'),
    meta: {
      title: '会员中心 - 高级功能 | SUNOSONG',
      description: 'SUNOSONG会员中心，解锁更多高级AI音乐创作功能',
      keywords: '会员中心,高级功能,AI音乐创作,SUNOSONG'
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/PersonalCenter.vue'),
    meta: {
      title: '个人中心 - 账户设置 | SUNOSONG',
      description: '管理你的SUNOSONG账户信息和偏好设置。',
      keywords: '个人中心,账户设置,SUNOSONG'
    }
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('../views/Payment.vue'),
    meta: {
      title: '支付中心 - 会员订阅 | SUNOSONG',
      description: '订阅SUNOSONG会员，享受更多高级AI音乐创作功能。',
      keywords: '支付中心,会员订阅,SUNOSONG'
    }
  },
  {    path: '/musicPlayer',    name: 'musicPlayer',    component: MusicPlayer,    meta: {      title: '音乐播放器 | SUNOSONG',      description: '在线播放SUNOSONG创作的音乐作品。',      keywords: '音乐播放器,在线播放,AI音乐,SUNOSONG'    }  },
  {    path: '/musicList',    name: 'musicList',    component: MusicList,    meta: {      title: '音乐列表 - 热门歌曲 | SUNOSONG',      description: '浏览SUNOSONG平台上的热门音乐作品和分类。',      keywords: '音乐列表,热门歌曲,AI音乐,SUNOSONG'    }  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('../views/ContactUs.vue'),
    meta: {
      title: '联系我们 | SUNOSONG',
      description: '有任何问题或建议？请联系SUNOSONG团队。',
      keywords: '联系我们,反馈,SUNOSONG'
    }
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('../views/FrequentlyAskedQuestions.vue'),
    meta: {
      title: '常见问题 - 帮助中心 | SUNOSONG',
      description: '查看SUNOSONG平台的常见问题和解答。',
      keywords: '常见问题,帮助中心,SUNOSONG'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/BriefIntroduction.vue'),
    meta: {
      title: '关于我们 - SUNOSONG | AI音乐创作平台',
      description: '了解SUNOSONG的使命、团队和发展历程，探索AI音乐创作的未来。',
      keywords: '关于我们,SUNOSONG,AI音乐创作,团队介绍'
    }
  }
]

// 记录已加载过的路由
const loadedRoutes = new Set()

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由切换时更新页面标题和meta标签
router.beforeEach((to, from, next) => {
  // 管理后台鉴权
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const adminToken = localStorage.getItem('adminToken');
    if (!adminToken) {
      next({ name: 'adminLogin' });
      return;
    }
  }
  
  // 只有当路由第一次加载时才显示加载动画
  if (typeof window !== 'undefined' && window.app && !loadedRoutes.has(to.path)) {
    window.app.isLoading = true
  }
  
  // 更新页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  // 更新meta description
  const description = document.querySelector('meta[name="description"]')
  if (description && to.meta.description) {
    description.setAttribute('content', to.meta.description)
  }
  
  // 更新meta keywords
  const keywords = document.querySelector('meta[name="keywords"]')
  if (keywords && to.meta.keywords) {
    keywords.setAttribute('content', to.meta.keywords)
  }
  
  // 更新canonical标签
  const canonical = document.querySelector('link[rel="canonical"]')
  if (canonical) {
    canonical.setAttribute('href', `https://www.sunosong.cn${to.path}`)
  }
  
  next()
})

// 路由切换完成后隐藏加载动画并标记为已加载
router.afterEach((to) => {
  // 将当前路由标记为已加载
  const isFirstLoad = !loadedRoutes.has(to.path)
  loadedRoutes.add(to.path)
  
  if (typeof window !== 'undefined' && window.app) {
    // 稍微延迟一下隐藏，确保页面已经渲染完成
    setTimeout(() => {
      window.app.isLoading = false
    }, 300)
  }
  
  // 页面访问埋点 - 仅当页面首次加载时发送
  if (isFirstLoad) {
    tracker.trackPageView(to.name || 'unknown', {
      page_title: to.meta.title || '',
      page_path: to.path
    })
  }
})

export default router
